// Canonical source_origin enum — case sensitive. AEs choose how an account
// came in; null means the rep has not yet set a source. Used on the
// accounts list and the account detail page; persisted to
// accounts.source_origin.
export const SOURCE_ORIGIN_VALUES = [
  "AE self-sourced",
  "BDR-sourced",
  "Marketing-sourced",
  "Partner-referral",
] as const;

export type SourceOrigin = (typeof SOURCE_ORIGIN_VALUES)[number];

export const SOURCE_ORIGIN_PLACEHOLDER = "Source not set";

export function isSourceOrigin(value: unknown): value is SourceOrigin {
  return (
    typeof value === "string" &&
    (SOURCE_ORIGIN_VALUES as readonly string[]).includes(value)
  );
}
